import { Flex } from "@chakra-ui/react"

const ProductComingSoon = ({
  datePublished,
  comingSoon,
}: {
  datePublished: string | null
  comingSoon: boolean
}) => {
  return (
    <Flex
      w={"full"}
      justifyContent={"center"}
      color={comingSoon ? "black" : "red.500"}
      fontWeight={"500"}
      py={10}
    >
      {comingSoon && datePublished
        ? `Releasing on ${datePublished}`
        : "Temporarily out of stock"}
    </Flex>
  )
}

export default ProductComingSoon
